import React from "react";
import "./css/Dashboard.css";

export default function Dashboard({ user }) {
  return (
    <div className="dashboard-container">
      {/* Header */}
      <div className="dashboard-header">
        <h1>Welcome, {user?.name || "User"} 👋</h1>
        <p>Your dashboard overview</p>
      </div>

      {/* Cards */}
      <div className="dashboard-cards">
        <div className="dashboard-card">
          <h3>👤 Profile</h3>
          <p><strong>Name:</strong> {user?.name}</p>
          <p><strong>Email:</strong> {user?.email}</p>
        </div>

        <div className="dashboard-card">
          <h3>📄 Job Applications</h3>
          <p>Track jobs you have applied for</p>
          <button>View Applications</button>
        </div>
      </div>

      {/* Activity */}
      <div className="dashboard-section">
        <h2>Recent Activity</h2>
        <ul>
          <li>✔ Account created successfully</li>
          <li>✔ Logged in to dashboard</li>
          <li>✔ Ready to apply for jobs</li>
        </ul>
      </div>
    </div>
  );
}
